import Vue from 'vue'
import App from './App.vue'
import './plugins/element.js'
import router from './router'

import './assets/site.css'
import './assets/fonts/iconfont.css'

Vue.config.productionTip = false

var vueParent = new Vue({
  router,
  render: h => h(App)
}).$mount('#app');


//全局配置ajax
(function () {
  $.ajaxSetup({
    xhrFields: {
      withCredentials: true  //支持附带详细信息
    },
    crossDomain: true,//请求偏向外域
    // contentType: 'application/x-www-form-urlencoded',
    error: res => {
      //请求异常处理登录
      if (res.status == 599) {
        //当前用户没有登录
        vueParent.$message({
          type: 'error',
          message: '您没有登录或登录超时',
          onClose: () => {
            vueParent.$router.replace('login');
          }
        });
      }
    }
  });


})();
